import script from "./ChangeSalesOrAgentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeSalesOrAgentForm.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeSalesOrAgentForm.vue?vue&type=style&index=0&id=7a39b460&lang=scss"

const __exports__ = script;

export default __exports__